type Props = {
  posts: any[]
}

export const ClassifiedFailedTable = ({posts}: Props) => {
  if (!Array.isArray(posts) || !posts.length) {
    return null
  }

  return (
    <div className='table-responsive'>
      <table className='table table-row-dashed align-middle gy-4'>
        <thead>
          <tr className='text-start text-muted fw-bolder fs-7 text-uppercase gs-0'>
            <th className='min-w-150px'>Title</th>
            <th className='min-w-125px'>Category</th>
            <th className='min-w-125px'>Subcategory</th>
            <th className='min-w-150px'>Location</th>
            <th className='min-w-100px'>Reason</th>
          </tr>
        </thead>
        <tbody className='text-gray-600 fw-bold'>
          {posts.map((item, idx) => {
            const location = item.location || {}
            return (
              <tr key={`failed-post-${idx}`}>
                <td>{item.title || '-'}</td>
                <td>{item?.category?.name || item?.category || '-'}</td>
                <td>{item?.subCategory?.name || item?.subCategory || '-'}</td>
                <td>
                  {[location.city, location.state].filter(Boolean).join(', ') || location.address || '-'}
                </td>
                <td>{item.reason || '-'}</td>
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  )
}

